import { Box } from '@chakra-ui/react';
import React from 'react';

export default function Divider() {
  return (
    <Box as='span' fontWeight={"700"}>|</Box>
  );
}
